export default {
  'Screenshot': 'Ekran görüntüsü',
}